/* FTR Hero Slider — arrows, pause/play, keyboard arrows, swipe, progress, countdown. Upload to theme /assets. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init(root) {
    if (!root || root._ftrHs) return; root._ftrHs = true;
    var slides = [].slice.call(root.querySelectorAll('.ftr-hs__slide'));
    var segs = [].slice.call(root.querySelectorAll('.ftr-hs__seg'));
    var n = slides.length, i = 0, prevT, hover = false, focus = false, inView = true;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var playing = root.dataset.autoplay === 'true' && n > 1 && !reduce;
    var stage = root.querySelector('.ftr-hs__stage'), cur = root.querySelector('[data-hs-cur]'), pp = root.querySelector('[data-hs-pp]');
    var hoverPause = root.dataset.hoverPause === 'true';

    slides.forEach(function (s) {
      var w = 0;
      [].forEach.call(s.querySelectorAll('.ftr-hs__line'), function (l, li) {
        l.style.setProperty('--ld', li * 90 + 'ms'); l.style.setProperty('--ld2', 120 + li * 110 + 'ms');
        [].forEach.call(l.querySelectorAll('.ftr-hs__w'), function (x) { x.style.setProperty('--d', 260 + w * 70 + 'ms'); x.style.setProperty('--d2', 120 + w * 80 + 'ms'); w++; });
      });
    });

    function state() {
      root.classList.toggle('is-stopped', !playing);
      root.classList.toggle('is-paused', !playing || (hoverPause && (hover || focus)) || !inView || document.hidden);
      if (pp) { pp.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow'); pp.setAttribute('aria-pressed', String(!playing)); }
      if (stage) stage.setAttribute('aria-live', playing ? 'off' : 'polite');
    }
    function activate() {
      slides.forEach(function (s, j) { var on = j === i; s.setAttribute('aria-hidden', on ? 'false' : 'true'); if ('inert' in s) s.inert = !on; });
      slides[i].classList.add('is-active');
      segs.forEach(function (g, j) { g.classList.remove('is-on'); g.classList.toggle('is-done', j < i); g.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (segs[i]) { void segs[i].offsetWidth; segs[i].classList.add('is-on'); }
      if (cur) cur.textContent = pad(i + 1);
      root.classList.toggle('card-off', slides[i].dataset.card === 'false');
    }
    function go(k) {
      if (n < 2) return; k = (k + n) % n; if (k === i) return;
      var old = slides[i];
      slides.forEach(function (s) { s.classList.remove('is-prev'); });
      old.classList.remove('is-active'); old.classList.add('is-prev');
      clearTimeout(prevT); prevT = setTimeout(function () { old.classList.remove('is-prev'); }, 950);
      i = k; activate();
    }
    root.go = go;

    segs.forEach(function (g, j) {
      g.addEventListener('click', function () { go(j); });
      var bar = g.querySelector('i'); if (bar) bar.addEventListener('animationend', function () { if (g.classList.contains('is-on') && playing) go(i + 1); });
    });
    var prev = root.querySelector('[data-hs-prev]'), next = root.querySelector('[data-hs-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    if (pp) pp.addEventListener('click', function () { playing = !playing; state(); });

    root.addEventListener('mouseenter', function () { hover = true; state(); });
    root.addEventListener('mouseleave', function () { hover = false; state(); });
    root.addEventListener('focusin', function () { focus = true; state(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focus = false; state(); } });
    document.addEventListener('visibilitychange', state);

    document.addEventListener('keydown', function (e) {
      if (!inView || n < 2 || e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target, tag = t && t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable)) return;
      if (e.key === 'ArrowRight') { go(i + 1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { go(i - 1); e.preventDefault(); }
    });

    var x0 = null, y0 = 0;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) go(i + (dx < 0 ? 1 : -1));
    }, { passive: true });

    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; state(); }, { threshold: .35 }).observe(root);

    var cd = root.querySelector('[data-hs-cd]');
    if (cd) {
      var tgt = new Date(cd.dataset.hsCd).getTime(), q = function (u) { return cd.querySelector('[data-u="' + u + '"]'); };
      var tick = function () { var d = Math.max(0, tgt - Date.now()); q('d').textContent = pad(Math.floor(d / 864e5)); q('h').textContent = pad(Math.floor(d / 36e5) % 24); q('m').textContent = pad(Math.floor(d / 6e4) % 60); q('s').textContent = pad(Math.floor(d / 1e3) % 60); };
      if (!isNaN(tgt)) { tick(); setInterval(tick, 1000); }
    }

    state(); activate();
    root.addEventListener('shopify:block:select', function (e) { var k = slides.indexOf(e.target.closest('.ftr-hs__slide')); if (k > -1) { playing = false; state(); go(k); } });
  }
  function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-ftr-hero]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
